export default [
  [ 
    //  融资方 / 上游企业
    {
      name: "首页",
      path: "/",
      paths: ["/"],
      icon: "&#xe731;",
      children: [],
    },
    {
      name: "电子债权凭证",
      path: "/certificate/list",
      paths: ["/certificate/list"],
      icon: "&#xe732;",
      opened: false,
      children: [
        {
          name: "持有凭证",
          path: "/certificate/list",
        },
        {
          name: "流转记录",
          path: "/certificate/record",
        },
      ],
    },
    // {
    //   name: "应收账款列表",
    //   path: "/checkout/list",
    //   paths: ["/checkout/list"],
    //   icon: "&#xe732;",
    //   children: [],
    // },
    {
      name: "融资申请",
      path: "/financing/index",
      paths: ["/financing/index"],
      icon: "&#xe739;",
      children: [],
    },
    {
      name: "融资订单 ",
      path: "/financingOrder/list",
      paths: ["/financingOrder/list"],
      icon: "&#xe738;",
      children: [],
    },

    {
      name: "用户中心",
      path: "/user/account/info",
      icon: "&#xe733;",
      paths: ["/user/account/info", "/user/company/info", "/user/qualifications/list", "/user/ca"],
      opened: false,
      children: [
        {
          name: "账户信息",
          path: "/user/account/info",
        },
        {
          name: "企业信息",
          path: "/user/company/info",
        },
        // {
        //   name: "关联核心企业",
        //   path: "/enterpriseCorrelation/list",
        // },
      ],
    },
  ],
  [
    // 核心企业
    {
      name: "首页",
      path: "/",
      paths: ["/"],
      icon: "&#xe731;",
      children: [],
    },
    {
      name: "应付账款列表",
      path: "/bill/payment",
      paths: ["/bill/payment", "/bill/paymentDetail"],
      icon: "&#xe732;",
      children: [],
    },
    // {
    //   name: "付款列表",
    //   path: "/bill/pay",
    //   paths: ["/bill/pay"],
    //   icon: "&#xe72e;",
    //   children: [],
    // },
    {
      name: "上游企业",
      path: "/enterprise/list",
      paths: ["/enterprise/list"],
      icon: "&#xe730;",
      children: [],
    },
    {
      name: "已签约金融机构",
      path: "/finance/list",
      paths: ["/finance/list"],
      icon: "&#xe72f;",
      children: [],
    },

    {
      name: "用户中心",
      path: "/user/account/info",
      icon: "&#xe733;",
      paths: ["/user/account/info", "/user/company/info", "/user/qualifications/list", "/user/ca"],
      opened: false,
      children: [
        {
          name: "账户信息",
          path: "/user/account/info",
        },
        {
          name: "企业信息",
          path: "/user/company/info",
        },
      ],
    },
  ],
];
